import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "loading-spinner"
}

import { computed } from 'vue';

interface Props {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  fullWidth?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    type: { default: 'button' },
    fullWidth: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const buttonClasses = computed(() => {
  const baseClasses = 'btn';
  const variantClass = `btn-${props.variant}`;
  const sizeClass = `btn-${props.size}`;
  const widthClass = props.fullWidth ? 'w-full' : '';
  const disabledClass = props.disabled || props.loading ? 'opacity-50 cursor-not-allowed' : '';

  return [baseClasses, variantClass, sizeClass, widthClass, disabledClass].join(' ');
});

function handleClick(event: MouseEvent) {
  if (!props.disabled && !props.loading) {
    emit('click', event);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: __props.disabled || __props.loading,
    class: _normalizeClass(buttonClasses.value),
    onClick: handleClick
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 10, _hoisted_1))
}
}

})